export default {
  namespaced: true,
  // vuex存储公共状态的文件
  state: {
    // 头部导航栏目前所在位置
    active: '/hlxj',
    // 侧边栏导航是否关闭，默认展开
    meunCollapse: false,
    // 路径名称
    // 获取sessionStorage中的数据
    menuNames: sessionStorage.getItem('menuNames') ? JSON.parse(sessionStorage.getItem('menuNames')) : [],
    // 历史记录
    // 获取sessionStorage中的数据
    navTab: sessionStorage.getItem('navTab') ? JSON.parse(sessionStorage.getItem('navTab')) : [],
    // 所有侧边导航的数据
    navs: [
      {
        label: '首页',
        path: '/hlxj',
        roles: ['admin', 'a', 'b', 'superAdmin']
      },
      {
        label: '好粮心产品',
        path: '/product',
        roles: ['admin', 'a', 'b', 'superAdmin'],
        children: [
          {
            label: '初见',
            path: '/productIntro'
          },
          {
            label: '相识',
            path: '/productIntro'
          },
          {
            label: '交心',
            path: '/productIntro'
          },
          {
            label: '口粮酒',
            path: '/productIntro'
          },
          {
            label: '小酒馆',
            path: '/productIntro'
          },
          {
            label: '粮心烧坊',
            path: '/productIntro'
          }
        ]
      },
      // {
      //   label: '新闻中心',
      //   path: '/news',
      //   roles: ['admin', 'a', 'b', 'superAdmin'],
      //   children: [
      //     {
      //       label: '娱乐营销',
      //       path: '/marketing'
      //     },
      //     {
      //       label: '光良动态',
      //       path: '/dynamic'
      //     }
      //   ]
      // },
      {
        label: '关于好粮心',
        roles: ['admin', 'a', 'b', 'superAdmin'],
        path: '/about'
      },
      {
        roles: ['a', 'b', 'superAdmin'],
        label: '招商合作',
        path: '/cooperation'
      },
      {
        roles: ['a', 'b', 'superAdmin'],
        label: '联系我们',
        path: '/contactus'
      }
    ]
  },
  getters: {

  },
  mutations: {
    // 修改头部导航位置
    SET_NEV (state, active) {
      if (active.substring(13, 0) === '/productIntro') {
        state.active = '/product'
      } else {
        state.active = active
      }
    },
    // 展开侧边栏
    OPEN_MENU (state) {
      state.meunCollapse = !state.meunCollapse
    },
    // 设置头部面包蟹导航
    SET_MENU_INFO (state, menuNames) {
      state.menuNames = menuNames
      // 存储到sessionStorage中
      sessionStorage.setItem('menuNames', JSON.stringify(state.menuNames))
    },
    // 清空头部的面包蟹导航
    CLEAR_MENUNAMES (state) {
      state.menuNames = []
      // 存储到sessionStorage中
      sessionStorage.setItem('menuNames', JSON.stringify(state.menuNames))
    },
    // 添加头部的历史记录导航
    ADD_TABS (state, tab) {
      // 添加时判断数组中是否已经存在
      const index = state.navTab.findIndex(navTabs => tab.path === navTabs.path)
      if (index !== -1) {
        return false
      }
      state.navTab.push(tab)
      // 存储到sessionStorage中
      sessionStorage.setItem('navTab', JSON.stringify(state.navTab))
    },
    // 删除头部的历史记录导航
    DELETE_TABS (state, index) {
      state.navTab.splice(index, 1)
      // 存储到sessionStorage中
      sessionStorage.setItem('navTab', JSON.stringify(state.navTab))
    }
  }
}
